import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import {
  MarketingFlowStep,
  UpdateMarketingFlowStepPayload
} from "../../marketing.types";
import { requestUpdateMarketingFlowStep } from "./updateMarketingFlowStep.request";

const useUpdateMarketingFlowStep = (
  options?: MutationOptions<
    MarketingFlowStep,
    ApiServiceError<ApiError>,
    UpdateMarketingFlowStepPayload
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestUpdateMarketingFlowStep,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({ queryKey: ["marketing", "flows"] });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useUpdateMarketingFlowStep;
